module.exports = __webpack_public_path__ + "img/teacher03.19bf9b81.png";